<template>
  <div class="chat">
    <step-one
      :form="form"
      :step="step"
      @changeStep="changeStep"
      v-if="step == 1"
    />
    <step-two
      :form="form"
      :step="step"
      @changeStep="changeStep"
      v-if="step == 2"
    />
    <step-three
      :form="form"
      :step="step"
      @changeStep="changeStep"
      v-if="step == 3"
    />
    <step-four
      :form="form"
      :step="step"
      @changeStep="changeStep"
      v-if="step == 4"
    />
    <step-five
      :form="form"
      :step="step"
      @changeStep="changeStep"
      v-if="step == 5"
    />
  </div>
</template>

<script>
import * as API from "@/services/individual/";
import StepOne from "./StepOne.vue";
import StepTwo from "./StepTwo.vue";
import StepThree from "./StepThree.vue";
import StepFour from "./StepFour.vue";
import StepFive from "./StepFive.vue";
import { loading } from "@/mixins/";
export default {
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
  },
  data() {
    return {
      step: 4,
      form: {
        data: {
          name: null,
          mail: null,
          phone: null,
          secureKey: null,
          agent: null,
        },
        messages: [
          {
            type: "service",
            text: "Katılım Emeklilik Müşteri Hizmetlerine Hoşgeldiniz.",
          },
          {
            type: "service",
            text: "Müşteri Temsilcimiz en kısa sürede sizinle iletişime geçecektir. Lütfen bekleyiniz.",
          },
        ],
      },
    };
  },
  mixins: [loading],
  computed: {
    chatstatus: function () {
      return this.$store.getters.getChatStatus;
    },
  },
  watch: {
    chatstatus: function (val) {
      if (val == "open") return;

      this.form.data = {
        name: null,
        mail: null,
        phone: null,
        secureKey: this.$store.getters.getChatSecureKey,
        agent: null,
      };

      this.form.messages = [
        {
          type: "service",
          text: "Katılım Emeklilik Müşteri Hizmetlerine Hoşgeldiniz.",
        },
        {
          type: "service",
          text: "Müşteri Temsilcimiz en kısa sürede sizinle iletişime geçecektir. Lütfen bekleyiniz.",
        },
      ];
    },
  },
  async created() {
    await this.getUser();
    this.chechChatStatus();
  },
  methods: {
    getUser: async function () {
      let vm = this;

      let response = await API.getUser();

      vm.form.data.name = response.result.fullName;
      vm.form.data.mail = response.result.email;
      vm.form.data.phone = response.result.phone;

      return vm.form;
    },
    chechChatStatus: function () {
      let vm = this;

      let status = vm.$store.getters.getChatStatus == "close";

      if (status) return (vm.form.data.secureKey = null);

      let messages = vm.$store.getters.getChatMessages;

      vm.form.messages = messages ? JSON.parse(messages) : [];
      vm.form.data.name = vm.$store.getters.getChatNickname;
      vm.form.data.mail = vm.$store.getters.getChatMail;
      vm.form.data.phone = vm.$store.getters.getChatPhone;
      vm.form.data.secureKey = vm.$store.getters.getChatSecureKey;
      vm.form.data.agent = vm.$store.getters.getChatAgent;

      vm.step = 3;
    },
    changeStep: function (step) {
      this.step = step;
    },
  },
};
</script>